@if (alertInfo.show) {
  <ngb-alert
    [type]="alertInfo.type"
    (closed)="alertInfo.show = false"
    >
    {{ alertInfo.message }}
  </ngb-alert>
}
<form [formGroup]="form">
  <div class="row g-3">
    @if (user?.userId) {
      <div class="col-sm-2 mt-2">
        <input-field
          type="text"
          [inputFormControl]="getUserIdInput()"
          label="User ID"
          placeholder="User ID"
          />
      </div>
    }
    <div class=" mt-2"  [ngClass]="user?.userId ? 'col-sm-5' : 'col-sm-6'">
      <input-field
        type="text"
        [inputFormControl]="getFirstNameInput()"
        label="First name"
        placeholder="Insert first name"
        />
    </div>
    <div class=" mt-2" [ngClass]="user?.userId ? 'col-sm-5' : 'col-sm-6'">
      <input-field
        type="text"
        [inputFormControl]="getLastNameInput()"
        label="Last name"
        placeholder="Insert last name"
        />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getEmailInput()"
        label="Email"
        placeholder="Email"
        />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field
        type="password"
        [inputFormControl]="getPasswordInput()"
        label="Password"
        placeholder="Password"
        />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field
        type="password"
        [inputFormControl]="getRepeatPasswordInput()"
        label="Repeat Password"
        placeholder="Password"
        />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getMobilePhoneInput()"
        label="Mobile Phone"
        placeholder="Mobile Phone"
        />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getTeamsIdInput()"
        label="Teams Id"
        placeholder="Teams Id"
        />
    </div>
    @if (onGlobalLab) {
      <div class="col-sm-4 mt-2">
        <select-department-field
          [selectFormControl]="getDepartmentSelect()"
          label="Department"
        ></select-department-field>
      </div>
    }
    <div class="col-sm-4 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getRankingInput()"
        label="Ranking"
        placeholder="Ranking"
        />
    </div>
    <div class="col-sm-2 mt-2">
      <select-user-status-field
        [selectFormControl]="getStatusSelect()"
        label="Status"
      ></select-user-status-field>
    </div>
    <!--
    <div class="col-sm-6 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getTimezoneSelect()"
        label="Timezone"
        placeholder="Insert timezone"
        />
    </div>
    -->
    <div class="col-sm-10 mt-2">
      <textarea-field
        [textareaFormControl]="getNotesTextArea()"
        label="Notes"
        placeholder="Notes"
        />
    </div>
  </div>

  <div class="text-center mt-4">
    <button
      type="button"
      class="btn btn-success px-4 py-2"
      (click)="submitForm()"
      >
      Save
    </button>
  </div>
</form>
